import { AuthenticationProvider } from './auth/AuthenticationContext';
import { AIProvider } from './data/AIContext';
import { ChatProvider } from './data/ChatContext';
import { ContactsProvider } from './data/ContactsContext';
import { JobsProvider } from './data/JobsContext';
import { NumbersProvider } from './data/NumbersContext';
import { OverviewStatsProvider } from './data/OverviewStatsContext';
import { PlansProvider } from './data/PlansContext';
import { SMSProvider } from './data/SMSContext';
import { NotificationsProvider } from './data/NotificationsContext';
import { SubscriptionsProvider } from './data/SubscriptionsContext';
import { UsersProvider } from './data/UsersContext';
import { FavoriteConversationsProvider } from './data/FavoriteConversationsContext';
import { UIProvider } from './ui/UIContext';
import { DomainsProvider } from './data/DomainsContext';
import { ScenariosProvider } from './data/ScenariosContext';
import { UserDetailStatsProvider } from './data/UserDetailStatsContext';
import { ScenarioChatProvider } from './data/ScenarioChatContext';
import { PageScaffoldProvider } from './ui/PageScaffoldContext';
import { AppProvider } from './data/AppContext';
import { TasksProvider } from './data/TasksContext';
import { LogsProvider } from './data/LogsContext';
import { ThemeProvider } from './ui/ThemeContext';
import { CompaniesProvider } from './data/companies/CompaniesContext';
import { TagsProvider } from './data/TagsContext';
import { EThemeNames } from '../../domain/types/themePresets';

const RootProviders: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <AuthenticationProvider>
      <UIProvider>
        <ThemeProvider defaultTheme={EThemeNames.LEEDFLOW_LIGHT}>
          <OverviewStatsProvider>
            <UsersProvider>
              <CompaniesProvider>
                <SubscriptionsProvider>
                  <ContactsProvider>
                    <JobsProvider>
                      <SMSProvider>
                        <NotificationsProvider>
                          <NumbersProvider>
                            <ChatProvider>
                              <FavoriteConversationsProvider>
                                <AIProvider>
                                  <PlansProvider>
                                    <DomainsProvider>
                                      <ScenariosProvider>
                                        <UserDetailStatsProvider>
                                          <ScenarioChatProvider>
                                            <PageScaffoldProvider>
                                              <TasksProvider>
                                                <LogsProvider>
                                                  <TagsProvider>
                                                    <AppProvider>
                                                      {children}
                                                    </AppProvider>
                                                  </TagsProvider>
                                                </LogsProvider>
                                              </TasksProvider>
                                            </PageScaffoldProvider>
                                          </ScenarioChatProvider>
                                        </UserDetailStatsProvider>
                                      </ScenariosProvider>
                                    </DomainsProvider>
                                  </PlansProvider>
                                </AIProvider>
                              </FavoriteConversationsProvider>
                            </ChatProvider>
                          </NumbersProvider>
                        </NotificationsProvider>
                      </SMSProvider>
                    </JobsProvider>
                  </ContactsProvider>
                </SubscriptionsProvider>
              </CompaniesProvider>
            </UsersProvider>
          </OverviewStatsProvider>
        </ThemeProvider>
      </UIProvider>
    </AuthenticationProvider>
  );
};

export default RootProviders;
